import { EXPLODE_SNOWFLAKES } from '../constants/actions';

export default function toggleSnowflakes(state = false, action) {
  switch (action.type) {
    case EXPLODE_SNOWFLAKES:
      return action.payload;
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/reducer-snowflakes.js
 **/